import { Space, Switch, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  /** Firmowe listy (wpłaty) liczą aktywną subskrypcję firmy, nie miejsce pracownika. */
  scope?: "user" | "company";
  disabled?: boolean;
};

const HINTS = {
  user: "Użytkownik ma przypisane miejsce w subskrypcji o statusie active, trialing lub free_period — to ci, którym plan daje uprawnienia. Konta wewnętrzne zespołu są pominięte.",
  company: "Firma ma co najmniej jedną subskrypcję o statusie active, trialing lub free_period. Firmy, w których miejsca zajmują wyłącznie konta wewnętrzne, są pominięte.",
};

/** Przełącznik „tylko z aktywną subskrypcją” — ten sam na wszystkich listach panelu. */
export const ActiveSubscriptionSwitch = ({
  checked,
  onChange,
  label = "Tylko z aktywną subskrypcją",
  scope = "user",
  disabled,
}: Props) => (
  <Space size={8} align="center">
    <Switch size="small" checked={checked} onChange={onChange} disabled={disabled} aria-label={label} />
    <Typography.Text
      style={{ cursor: disabled ? undefined : "pointer", userSelect: "none" }}
      onClick={() => !disabled && onChange(!checked)}
    >
      {label}
    </Typography.Text>
    <Tooltip title={HINTS[scope]}>
      <Typography.Text type="secondary">
        <InfoCircleOutlined />
      </Typography.Text>
    </Tooltip>
  </Space>
);
